import React from "react"

import { AppInsuranceAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { insurance } from "@signals"
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersInsuranceAutocomplete({ onOptions, onFinishAjax, ...props }) {
	return <AppInsuranceAutocomplete
		value={insurance.value}
		onChange={e => insurance.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/insurances`}
		onFinishAjax={chainFinish(onFinishAjax, onOptions)}
		{...props}
	/>
}